import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";

import { useCallback } from "react";
import Sale from "../../../../utilities/data/model/Sale";
import { FlatList } from "react-native";
import { Item } from "./components/Item";
import { Divider } from "@towersystems/roam-common-native";
import SaleItem from "../../../../utilities/data/model/SaleItem";

const getObservables = ({ sale }: { sale: Sale }) => ({
  items: sale.items.observe(),
});

export interface SaleSaleItemsSummaryRendererProps
  extends ExtractedObservables<ReturnType<typeof getObservables>> {
  sale: Sale;
}

const SaleSaleItemsSummaryRenderer = ({
  items,
}: SaleSaleItemsSummaryRendererProps) => {
  const renderItem = useCallback(({ item }: { item: SaleItem }) => {
    return <Item item={item} />;
  }, []);
  return (
    <FlatList
      style={{ overflow: "visible" }}
      scrollEnabled={true}
      ItemSeparatorComponent={Divider}
      data={items}
      renderItem={renderItem}
    ></FlatList>
  );
};

const enhance = withObservables(["sale"], getObservables);

export const SaleSaleItemsSummary = enhance(SaleSaleItemsSummaryRenderer);
